'use strict';

var StepMarketSharePanelDirective = function StepMarketSharePanelDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/step-market-share-panel.html'),
    controller: 'StepMarketSharePanelController',
    link: function link(scope) {
      scope.$on('scheduleChange:stepEntered', scope.stepEntered);
    }
  };
};
StepMarketSharePanelDirective.$inject = [];
module.exports = StepMarketSharePanelDirective;